import { useState } from 'react';

interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-white shadow-md'
      }`}
    >
      <div className="w-full px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <a href="/" className="cursor-pointer">
              <img
                src="https://public.readdy.ai/ai/img_res/1d556993-a58d-43bc-bae6-ef5f64cff7ce.png"
                alt="REAL"
                className="h-12 w-auto"
              />
            </a>
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            <a
              href="/"
              className="text-sm font-medium text-gray-900 hover:text-gray-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              トップページ
            </a>
            <a
              href="https://www.1994real.com/catalog.html"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-medium text-gray-900 hover:text-gray-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              カタログ
            </a>
            <a
              href="https://ameblo.jp/real-inouefumihide/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-medium text-gray-900 hover:text-gray-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              ブログ
            </a>
            <a
              href="https://www.instagram.com/real_eyewear/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-lg text-gray-900 hover:text-gray-600 transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line"></i>
            </a>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden text-2xl text-gray-900 cursor-pointer"
          >
            <i className={mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="lg:hidden bg-white shadow-lg">
          <div className="px-6 py-4 space-y-3">
            <a
              href="/"
              className="block w-full text-left text-sm font-medium text-gray-900 hover:text-gray-600 cursor-pointer"
            >
              トップページ
            </a>
            <a
              href="https://www.1994real.com/catalog.html"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full text-left text-sm font-medium text-gray-900 hover:text-gray-600 cursor-pointer"
            >
              カタログ
            </a>
            <a
              href="https://ameblo.jp/real-inouefumihide/"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full text-left text-sm font-medium text-gray-900 hover:text-gray-600 cursor-pointer"
            >
              ブログ
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
